import { render, staticRenderFns } from "./SelectOrg.vue?vue&type=template&id=0c99f454&scoped=true"
import script from "./SelectOrg.vue?vue&type=script&lang=js"
export * from "./SelectOrg.vue?vue&type=script&lang=js"
import style0 from "./SelectOrg.vue?vue&type=style&index=0&id=0c99f454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c99f454",
  null
  
)

export default component.exports